module.exports = __webpack_public_path__ + "img/senior-woman-with-walker-at-home-Q8CNHTT-min.74d1dc37.jpg";